module.exports = __webpack_public_path__ + "media/6.194288fe.mp3";